// @flow
import * as React from 'react'
import { Typography } from '@material-ui/core'
import { Assignment } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 20,
  },
  icon: {
    fontSize: 100,
    color: theme.palette.primary.light,
    marginBottom: theme.spacing(2),
  },
}))

const NoForms = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Typography align="center" variant="h5" color="primary" paragraph>
        No Forms
      </Typography>
      <Assignment className={classes.icon} />
      <Typography align="center" paragraph color="textSecondary">
        This environment does not have any forms with the HCMS submission event
        configured.
      </Typography>
      <Typography align="center" color="textSecondary">
        Try selecting another environment.
      </Typography>
    </div>
  )
}

export default NoForms
